import { Injectable } from "@angular/core";
import { GisTokenService } from "../../../../gis/services/gis-token.service";
import { GISConfig } from "../../../../gis/models/gis-config.model";
import { Observable, of, from } from "rxjs";
import { loadModules } from "esri-loader";
import { flatMap, concatMap } from "rxjs/operators";

@Injectable()
export class CasingPlanAlertService {
    config: GISConfig;

    constructor(
        public _tokenService: GisTokenService

    ) {
        this.config = window["GIS.Conf"] as GISConfig;
    }

    queryFeatureLayer(serviceConfig: GISServiceConfig, point: p, options?: { distanceBuffer: number, units: string, query?: string }): Observable<any> {
        let modules$ = from(loadModules([
            "esri/tasks/support/Query",
            "esri/tasks/QueryTask",
            "esri/geometry/Point"
        ]));
        let token$ = this._tokenService.getToken();
        return modules$.pipe(concatMap(
            () => token$,
            ([Query, QueryTask, Point], token) => {
                let queryTask = new QueryTask({
                    url: serviceConfig.url.indexOf(this.config.serverEndPoint) !== -1 ?
                        `${serviceConfig.url}/${serviceConfig.layerId}?f=json&token=${token.token}`
                        : `${serviceConfig.url}/${serviceConfig.layerId}`
                });

                let query = new Query();
                query.spatialRelationship = "intersects";
                query.geometry = new Point(point);
                query.returnGeometry = false;
                query.outFields = ["*"];

                if (options) {
                    query.distance = options.distanceBuffer;
                    query.units = options.units;

                    if (options.query)
                        query.where = options.query;
                }

                return from(queryTask.execute(query));
            }
        )).pipe(concatMap((result) => { return result }));
    }

    queryImageServer(serviceConfig: GISServiceConfig, point: p): Observable<any> {
        let modules$ = from(loadModules([
            "esri/tasks/ImageServiceIdentifyTask",
            "esri/tasks/support/ImageServiceIdentifyParameters",
            "esri/geometry/Point"
        ]));
        let token$ = this._tokenService.getToken();

        return modules$.pipe(concatMap(
            () => token$,
            ([ImageServiceIdentifyTask, ImageServiceIdentifyParameters, Point], token) => {
                let imageServiceIdentityTask = new ImageServiceIdentifyTask(`${serviceConfig.url}?f=json&token=${token.token}`);
                let params = new ImageServiceIdentifyParameters();
                params.geometry = new Point(point);
                params.returnGeometry = false;

                return from(imageServiceIdentityTask.execute(params));
            })).pipe(concatMap((result) => { return result }));
    }

    getGISService(gisServiceUrl: string): Observable<any> {
        return from(loadModules([
            "esri/request"
        ])).pipe(concatMap(([esriRequest]) => from(this._tokenService.getToken()).pipe(flatMap((token) =>
            esriRequest(gisServiceUrl + "?f=json&token=" + token,
                {
                    responseType: "json",
                    token: token
                })))
        ));
    }
}

export type GISServiceConfig = { url: string, layerId: string };

type p = {
    latitude: number,
    longitude: number
}
